export const BUTTON_TYPE = 'MAT-MENU-ITEM';
export const BUTTON_STYLE = 'MAT-MENU-ACTION-ITEM';
export const MY_PROFILE = $localize`My Profile`;
export const CHNGPSWD = $localize`Change Password`;
export const LOGOUT = $localize`Logout`;
export const ARIA_LABEL = 'Help Icon';
export const ARIA_HIDDEN = 'false';
export const HELP = 'help_outline';
export const ACCOUNT = 'person_outline';
export const Organization = 'business';
export const LOCK = 'lock_outline';
export const LOGOUT_ICON = 'logout';
export const DROPDOWN = 'arrow_drop_down_outline';
export const SUPERADMIN_TABS = [
  $localize`Organizations`,
  $localize`Applications`,
  $localize`Reports`,
  // $localize`News Management`, <= work in progress, disabled for now
];
export const USER_TABS = [
  $localize`Instrument Run`,
  $localize`SV Test Panel`,
  $localize`Sample`,
  $localize`Reference File Management`,
  $localize`Analysis Tab`,
];
export const ADMIN_TABS = [
  $localize`Instrument Run`,
  $localize`SV Test Panel`,
  $localize`Sample`,
  $localize`User Management`,
  $localize`Reference File Management`,
  $localize`Analysis Tab`,
];
